/* eslint-disable no-shadow */
import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'

import { useStyles } from '../styles'
import TableAA from '../../Tables/TableAA'
import TableAAPP from '../../Tables/TableAAPP'

const StreetMarketDeportCard = (props) => {
  const {
    totalDeportives = [],
    selectedDate,
    gTotalDeportives = [],
    totalDeportivesSegment,
    gTotalDA,
    gTotalDB,
  } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Mercado DEPORTIVAS</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA
              array={totalDeportives}
              selectedDate={selectedDate}
              disableAA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución DEPORTIVAS en miles</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                gTotalDeportives,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              id='12'
              options={Utils.optionsSimpleBarChart}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAAPP
              array={totalDeportivesSegment}
              param="SUBSEGMENTO"
              selectedDate={selectedDate}
              title="SUBSEGMENTO"
              AA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución DEPORTIVAS por segmento Año</h3>
            <br />
            <Bar
              data={Utils.barLineDataGroup(gTotalDA, 'Y')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución DEPORTIVAS por segmento Mes</h3>
            <br />
            <Bar
              data={Utils.barLineDataGroup(gTotalDB, 'MES')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default StreetMarketDeportCard
